import React from 'react'
import { useTranslation } from 'react-i18next';
import AppStore from '../../assets/icons/appstore.svg';
import AppStoreNL from '../../assets/icons/appstore-nl.svg';
import PlayStore from '../../assets/icons/playstore.svg';
import PlayStoreNL from '../../assets/icons/playstore-nl.svg';
import _ from 'lodash'

const AppButtons = ({ entity }) => {
  const { i18n } = useTranslation();
  const appStore = _.get(entity, 'fieldAppstoreUrl.url.path', null);
  const playStore = _.get(entity, 'fieldPlaystoreUrl.url.path', null);;

  return (
    <div className="app-buttons">
      <div className="button-group">
        {appStore && (
          <a href={appStore} target="_blank" rel="noopener noreferrer">
            {(i18n.language.toLowerCase() == 'nl' ? <AppStoreNL /> : <AppStore />)}
          </a>
        )}
        {playStore && (
          <a href={playStore} target="_blank" rel="noopener noreferrer">
            {(i18n.language.toLowerCase() == 'nl' ? <PlayStoreNL /> : <PlayStore />)}
          </a>
        )}
      </div>
    </div>
  );
}

export default AppButtons
